






















































































































































import { Component, Vue, Ref, Watch, Prop } from 'vue-property-decorator';
import { FormModel } from 'ant-design-vue';
import moment, {Moment} from 'moment';
import { ITodoTypeOptions, todoTypeTool } from '@/utils/todo';
import { generateUUID } from '@/utils/other';
import OwnerForm from './ownerForm.vue';
import { IOwnerInfo, IFormItemInfo } from '../types';
import MultipleSelectTeam from '@/components/multipleSelectTeam.vue';

type IUserDetailInfo = IUser.IResponse.IUserDetailInfo;
type ISettlementUnitInfo = ISettlementUnit.IResponse.ISettlementUnitInfo;
type IBatchCreateTodoParams = ITodo.IRequest.IBatchCreateTodoParams;

interface IForm {
  moduleId: string;
  typeId: string[];
  typeName: string;
  title: string;
  description: string;
  owners: IOwnerInfo[];
  due: Moment | null;
  dues: string[];
}

interface IGrabForm {
  manDay: number | null;
  settlementUnitId: string;
  teamIds: string[];
}

@Component({
  components: {
    OwnerForm,
    MultipleSelectTeam,
  },
})
export default class TodoForm extends Vue {
  @Ref() private readonly editTodoForm!: FormModel;
  @Ref() private readonly grabFormRef!: FormModel;
  @Prop({default: () => null}) private readonly formInfo!: IFormItemInfo | null;
  @Prop({default: () => null}) private readonly moduleDue!: string | null;
  @Prop({default: () => [], required: true}) private readonly memberOptions!: IUserDetailInfo[];
  @Prop({default: () => [], required: true}) private readonly settlementUnitOptions!: ISettlementUnitInfo[];
  @Prop({default: () => [], required: true}) private readonly todoTypeOptions!: ITodoTypeOptions[];
  private isBatchCreate: boolean = false;
  private isGrab: boolean = false;
  private dateCheckBoxOpen = false;
  private checkBoxDates: Moment[] = [];
  private typeValue: number | null = 0;
  private typeFormat: number = 2;
  private ownerValue: number = 0;
  private form: IForm = {
    moduleId: '',
    typeId: [],
    typeName: '',
    title: '',
    description: '',
    owners: [],
    due: null,
    dues: [],
  };
  private grabForm: IGrabForm = {
    manDay: null,
    settlementUnitId: '',
    teamIds: [],
  };
  get rules() {
    const baseRule = {
      title: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      typeId: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      description: [{ required: this.isGrab, message: () => this.$t('form.required'), trigger: 'change'}],
    };
    if (this.isBatchCreate) {
      return {
        ...baseRule,
        dues: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
      };
    }
    return {
      ...baseRule,
      due: [{ required: true, message: () => this.$t('form.required'), trigger: 'change'}],
    };
  }
  get grabRules() {
    return {
      teamIds: [{ required: true, trigger: 'change', message: () => this.$t('form.required')}],
      manDay: [{ required: true, trigger: 'blur', message: () => this.$t('form.required') }],
      settlementUnitId: [{ required: true, trigger: 'change', message: () => this.$t('form.required') }],
    };
  }
  get checkedDates() {
    this.form.dues = this.checkBoxDates.map((item) => item.format('YYYY-MM-DD'));
    return this.checkBoxDates.map((item) => item.format('YYYY/MM/DD'));
  }
  public validate() {
    let validateResult: boolean = false;
    this.editTodoForm.validate((valid) => {
      validateResult = valid;
      if (this.isGrab) {
        this.grabFormRef.validate((valid2) => {
          if (!valid2) {
            validateResult = false;
          }
        });
      }
      if (!this.isGrab && !this.validateOwners()) {
        validateResult = false;
      }
      if (!this.checkValue()) {
        this.$message.warning(this.$t('todo.totalValueMsg').toString());
        validateResult = false;
      }
    });
    return validateResult;
  }
  public generateTodoData() {
    return this.isBatchCreate ? this.batchCreateTodo() : this.createTodo();
  }
  @Watch('isBatchCreate')
  private watchIsBatchCreate(newValue: boolean) {
    if (!newValue) {
      this.dateCheckBoxOpen = false;
    }
  }
  private created() {
    this.readyFormData();
  }
  private disabledDate(current: Moment) {
    let endDate = moment().endOf('year');
    const startDate = moment().startOf('day');
    if (this.moduleDue) {
      endDate = moment(this.moduleDue).endOf('day');
    }
    return current && (current < startDate || current > endDate);
  }
  private readyFormData() {
    this.form = {
      moduleId: '',
      typeId: [],
      typeName: '',
      title: '',
      description: '',
      owners: [],
      due: null,
      dues: [],
    };
    this.grabForm = {
      manDay: null,
      settlementUnitId: '',
      teamIds: [],
    };
    if (this.formInfo) {
      const {due, isBatchCreate, checkBoxDates, formId, typeValue, ownerValue,
        isGrab, grabInfo, ...form} = this.formInfo;
      Object.assign(this.form, form);
      this.form.due = due ? moment(due) : null;
      this.isBatchCreate = isBatchCreate;
      this.checkBoxDates = checkBoxDates.map((dateString) => moment(dateString));
      this.ownerValue = ownerValue;
      this.typeValue = typeValue;
      this.isGrab = isGrab;
      Object.assign(this.grabForm, grabInfo);
      this.updateTypeFormat(this.formInfo.typeId);
    }
    if (!this.isGrab && this.form.owners.length === 0) {
      this.addOwner();
    }
  }
  private createTodo() {
    const {moduleId, typeId, typeName, title, description, owners, due} = this.form;
    const dueValue = due ? due.format('YYYY-MM-DD') : '';
    const {manDay, settlementUnitId, teamIds} = this.grabForm;
    const todoList: IBatchCreateTodoParams[] = [];
    if (this.isGrab) {
      todoList.push({
        id: generateUUID(),
        title,
        moduleId,
        description,
        typeId: typeId[typeId.length - 1],
        typeName,
        isBonus: false,
        manDay: manDay || 0,
        owner: null,
        settlementConfigurationId: settlementUnitId,
        due: dueValue,
        comment: '',
        patternType: 1,
        teamIds,
      });
    } else {
      owners.forEach((owner) => {
        todoList.push({
          id: generateUUID(),
          title,
          moduleId,
          description,
          typeId: typeId[typeId.length - 1],
          typeName,
          isBonus: false,
          manDay: owner.value || 0,
          owner: owner.ownerId,
          settlementConfigurationId: owner.settlementUnitId,
          due: dueValue,
          comment: '',
          patternType: 0,
          teamIds: [],
        });
      });
    }
    return todoList;
  }
  private batchCreateTodo() {
    const {moduleId, typeId, typeName, title, description, owners, dues} = this.form;
    const {manDay, settlementUnitId, teamIds} = this.grabForm;
    const todoList: IBatchCreateTodoParams[] = [];
    if (this.isGrab) {
      dues.forEach((due) => {
        todoList.push({
          id: generateUUID(),
          moduleId,
          typeId: typeId[typeId.length - 1],
          typeName,
          title,
          isBonus: false,
          manDay: manDay || 0,
          description,
          owner: null,
          settlementConfigurationId: settlementUnitId,
          due,
          comment: '',
          patternType: 1,
          teamIds,
        });
      });
    } else {
      owners.forEach((owner) => {
        dues.forEach((due) => {
          todoList.push({
            id: generateUUID(),
            moduleId,
            typeId: typeId[typeId.length - 1],
            typeName,
            title,
            isBonus: false,
            manDay: owner.value || 0,
            description,
            owner: owner.ownerId,
            settlementConfigurationId: owner.settlementUnitId,
            due,
            comment: '',
            patternType: 0,
            teamIds: [],
          });
        });
      });
    }
    return todoList;
  }
  private duesChange(e: Event | any, date: Moment) {
    let newDates: Moment[] = [];
    if (e.target.checked) {
      newDates = [...this.checkBoxDates];
      newDates.push(date);
    } else {
      newDates = this.checkBoxDates.filter((item) => item.format('YYYY-MM-DD') !== date.format('YYYY-MM-DD'));
    }
    newDates.sort((a, b) => {
      return a.valueOf() - b.valueOf();
    });
    this.checkBoxDates = [...newDates];
  }
  private addOwner() {
    this.form.owners.push({
      id: generateUUID(),
      ownerId: '',
      value: null,
      settlementUnitId: '',
    });
  }
  private removeOwner(index: number, ownerId: string) {
    if (this.form.owners.length <= 1) {
      this.displayMessage();
      return;
    }
    this.form.owners.splice(index, 1);
    this.calculateTotalValue();
  }
  private validateOwners(): boolean {
    let validateResult = true;
    if (this.form.owners.length < 1) {
      validateResult = false;
    }
    this.form.owners.forEach((item) => {
      if (!(this.$refs[`owner-${item.id}`] as OwnerForm[])[0].validate()) {
        validateResult = false;
      }
    });
    return validateResult;
  }
  private displayMessage() {
    this.$message.warning(this.$t('todo.ownerMsg').toString());
  }
  private onTypeChange(value: string[], selectedOptions: ITodoTypeOptions[]) {
    if (value.length === 0) {
      this.typeValue = null;
      this.form.typeName = '';
      return;
    }
    this.form.typeName = selectedOptions[selectedOptions.length - 1].label;
    const TodoType = todoTypeTool.getTodoTypeById(value[value.length - 1]);
    if (TodoType) {
      this.typeValue = TodoType.typeValue;
    } else {
      this.typeValue = null;
    }
    this.updateTypeFormat(value);
  }
  private updateTypeFormat(typeId: string[]) {
    if (typeId.length === 0) {
      return;
    }
    const TodoType = todoTypeTool.getTodoTypeById(typeId[typeId.length - 1]);
    if (TodoType) {
      this.typeFormat = TodoType.formatType === 1 ? 0 : 2;
    } else {
      this.typeFormat = 2;
    }
  }
  private calculateTotalValue() {
    const values: number[] = [];
    this.form.owners.forEach((owner) => {
      if (typeof owner.value === 'number') {
        values.push(owner.value);
      }
    });
    this.ownerValue = values.reduce((total, value) => {
      if (typeof value === 'number') {
        return total + value;
      }
      return total;
    }, 0);
  }
  private checkValue() {
    if (typeof this.typeValue === 'number') {
      if (this.isGrab) {
        return this.typeValue >= this.grabForm.manDay!;
      }
      return this.typeValue >= this.ownerValue ;
    }
    return true;
  }
  private removeForm() {
    this.$emit('remove');
  }
  private copyForm() {
    const {moduleId, typeId, typeName, title, description, owners} = this.form;
    const formItemInfo: IFormItemInfo = {
      formId: '',
      moduleId,
      typeId,
      typeName,
      title,
      description,
      owners,
      due: this.form.due ? this.form.due.toJSON() : null,
      dues: this.form.dues,
      isBatchCreate: this.isBatchCreate,
      checkBoxDates: this.checkBoxDates.map((date) => date.toJSON()),
      typeValue: this.typeValue,
      ownerValue: this.ownerValue,
      isGrab: this.isGrab,
      grabInfo: {...this.grabForm},
    };
    this.$emit('copy', formItemInfo);
  }
}
